export default "__VITE_ASSET__CpFVICjX__"